/* global Symbol */
// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';

import ButtonGroup from '../../../../../../common/components/c_ButtonGroup';
import ProgressComponent from '../../../../../../common/components/C_ProgressComponent';
import FlatButton from '../../../../../../common/components/c_FlatButton';

// js utilities
import _ from 'lodash';

import SearchIcon from '../../../../../../common/svgs/SearchIcon';
import { defaultOrdering } from '../../../../../../lib/dropdowns';

// class name
// import cx from 'classnames';

@connect(store => ({
  labels: store.labels
}), null, null, { withRef: true })
export default class Skills extends ProgressComponent {
  static propTypes = {
    user: PropTypes.object,
    profileId: PropTypes.number.isRequired,
    skills: PropTypes.object.isRequired,
    model: PropTypes.string.isRequired,
    viewState: PropTypes.object,
    tempState: PropTypes.object.isRequired,
    updateTempState: PropTypes.func.isRequired,
    categoryId: PropTypes.number,
    title: PropTypes.string,
    validation: PropTypes.object,
    validationKey: PropTypes.string,
    labels: PropTypes.object.isRequired,
  }

  constructor(props, context) {
    super(props, context);
    this.getSkillList = ::this.getSkillList;
    this.getParentSkillHeaders = ::this.getParentSkillHeaders;
  }

  state = {
    searchTags:[],
    validation: Object.assign(
      this.CustomValidation,
      _.pick(this.props.validation, [])
    )
  }

  static defaultProps = {
    user: {}
  }

  get CustomValidation() {
    const comp = this;
    let key = _.get(comp, 'props.categoryId');
    const CustomValidator = function() {
      const model = () => {
        key = _.get(comp, 'props.categoryId');
        return Object.assign({}, _.get(comp, `props.skills[${key}]`), _.get(comp, `props.tempState[${comp.props.model}][${key}]`));
      };
      this.skills = {
        custom: {
          func: (val) => {
            return !_.isEmpty(_.filter(model(), (s) => s.deleted !== Symbol.for('_deleted_'))) || !_.isEmpty(val);
          },
          message: 'Must Select at Least One'
        }
      };
    };

    return new CustomValidator();
  }

  onChange(event, value, parentId) {
    value = _.map(value, str => _.replace(str, /\[/g, '(').replace(/\]/g, ')'));
    if (parentId) {
      // get all selected skills from tempstate that are 1) not deleted 2) not of the current Parent
      // append it to value
      const existingSkills = _.keysIn(
        _.pickBy(
          _.get(this.props.tempState, [this.props.model, this.props.categoryId], _.get(this.props.skills, [this.props.categoryId], {})),
          s => !s.deleted && s.parentSkillId !== parentId
        ));
      value = value.concat(existingSkills);
    }


    const diff = _.difference(_.keysIn(this.props.skills[this.props.categoryId]), value);
    const skills = _.reduce(value.concat(diff), (category, skill) => {
        const selectedSkill = this.props.staticData.skillTypes.find((skillType) => skillType.name === skill) || {};
        category[skill] = {id: selectedSkill.id || null, categoryId:this.props.categoryId, name: skill, parentSkillId: selectedSkill.parentSkillId || null, deleted: diff.includes(skill) ? Symbol.for('_deleted_') : null};
        return category;
      }, {});
    if(_.get(this.props.tempState, this.props.model)) {
      this.props.updateTempState(`${this.props.model}`, `${this.props.categoryId}`, null, skills);
    } else {
      this.props.updateTempState(`${this.props.model}`, '', null, {});
      setTimeout(() => {
        this.props.updateTempState(`${this.props.model}`, `${this.props.categoryId}`, null, skills);
      });
    }
  }

  onItemChange(target, prop, event, value) {
    const skills = _.merge({}, _.get(this.props.skills, [this.props.categoryId], {}), _.get(this.props.tempState, [this.props.model, this.props.categoryId], {}));
    skills[target.name][prop] = value;
    if(_.get(this.props.tempState, this.props.model)) {
      this.props.updateTempState(`${this.props.model}`, `${target.categoryId}`, null, skills);
    }
    else {
      this.props.updateTempState(`${this.props.model}`, '', null, {});
      setTimeout(() => {
        this.props.updateTempState(`${this.props.model}`, `${target.categoryId}`, null, skills);
      });
    }
  }

  onDelete(target, event) {
    this.onItemChange(target, 'deleted', event, Symbol.for('_deleted_'));
  }

  searchOnChange(e) {
    _.debounce(
      this.setState({
        searchTags: e.target.value.toLowerCase().trim()
      }), 200);
  }

  mapObject(object, callback) {
    return Object.keys(object).map(function (key) {
      return callback(object[key], key);
    });
  }

  getSkillList() {
    /**
      selectedSkillIds is a lookup dictionary of ids of selected skills:
      selectedSkillIds = {
        870: true,
        871: true,
        872: true,
      }
     **/
    const selectedSkillIds = _.reduce(this.props.skills, (ids, categories) => {
      if (!_.isEmpty(categories)) {
        _.forEach(categories, (category) => { ids[category.id] = true; });
      }
      return ids;
    }, {});

    return this.props.staticData.skillTypes
      .filter((skill) => {
        const belongsToCategory = skill.skillCategoryTypeId === this.props.categoryId;
        const isParentNull = skill.parentSkillId === null;
        const belongsToParent = !isParentNull && selectedSkillIds[skill.parentSkillId];
        return belongsToCategory && (isParentNull || belongsToParent);
      })
      .map((skill) => { return {primaryText: skill.name, parentSkillId: _.get(skill, 'parentSkillId', null)};});
  }

  getParentSkillHeaders(skillList) {

    return _.uniqBy(skillList, 'parentSkillId')
      .map((skill) => {
        return {
          name: _.get(this.props.staticData.skillTypes.find((skillType) => skillType.id === skill.parentSkillId), 'name', ''),
          id: skill.parentSkillId || null
        };
      })
      .filter((header) => header.id !== null)
      .sort((skillA, skillB) => skillA.name.localeCompare(skillB.name))
    ;

  }

  render() {

    const items = _.pickBy(_.get(this.props.tempState, [this.props.model, this.props.categoryId], _.get(this.props.skills, [this.props.categoryId], {})), s => !s.deleted);
    const values = _.keysIn(items);

    const skillList = this.getSkillList();

    // Hide the add button when the skill category is INDUSTRIES (leave for FIRM_TYPES)
    const skillCategory = this.props.staticData.skillCategoryTypes.find(
      skillCategoryType => skillCategoryType.id === this.props.categoryId);
    const showAdd = !(skillCategory && skillCategory.hardcodelink === 'INDUSTRIES');

    const parentSkillHeaders = this.getParentSkillHeaders(skillList);

    // adding option none for Special Areas of Knowledge, Management Systems, Rating Systems by WAHV-905;
    if (this.props.hasNone) {
      skillList.unshift({primaryText: 'None'});
    }

    const visibleList = _.reduce(skillList,
        (skillsList, skill) => {
            if (this.state.searchTags === '' || skill.primaryText.toLowerCase().indexOf(this.state.searchTags) > -1) {
              skillsList.push(skill.primaryText);
            }
            return skillsList;
          },
        []);

    return (
      <div className='application-section-container clearfix skills'>
        <div
          className='form-heading'
          data-id={`${this.props.title} title`}>
          {this.props.title}
        </div>

        {
          this.props.description &&
          <div className='form-description'>{this.props.description}</div>
        }

        <div className='search center-column-3'>
          <div className='search-input-container'>
            <SearchIcon />
            <input data-id='Search'
                   ref='search'
                   className='search-input'
                   type='text'
                   placeholder='Search...'
                   onKeyUp={::this.searchOnChange}/>
          </div>
        </div>
        <div>{this.props.labels.Application.skillsSubheading}</div>
          {
            parentSkillHeaders.length ? (
              <div>
              {
                parentSkillHeaders.map((parent) => {
                  const selectedSkills = _.filter(items, (item) => item.parentSkillId === parent.id).map((skill) => skill.name);
                  const menuItems = skillList.filter((s) => s.parentSkillId === parent.id);
                  return (
                    <div className='skill-section'>
                      <span className='skill-section-parent'>{parent.name}</span>
                      <ButtonGroup
                        menuItems={menuItems.sort(defaultOrdering)}
                        visibleItems={visibleList.sort(defaultOrdering)}
                        value={selectedSkills}
                        validation={this.props.validation[this.props.validationKey]}
                        onErrorChange={this.props.errorUpdate}
                        onChange={(event, value) => this.onChange(event, value, parent.id)}
                      />
                    </div>);
                })
              }
            </div>) :
            <ButtonGroup
              menuItems={skillList.sort(defaultOrdering)}
              visibleItems={visibleList.sort(defaultOrdering)}
              value={values}
              showAdd={showAdd}
              validation={this.props.validation[this.props.validationKey]}
              onErrorChange={this.props.errorUpdate}
              onChange={::this.onChange}
            />
          }
        <ul className={`skill-list ${values.length ? '' : 'empty'}`}>
          {
            this.mapObject(items, (row, index) => (
              <li key={index} className='skill-item'>
                <div data-id={`SkillName${index}`} className='name'>{row.name}</div>
                <div className='actions'>
                  <FlatButton
                    data-id={`Remove${index}`}
                    label='Remove'
                    data-id={`Remove${index}`}
                    onClick={this.onDelete.bind(this, row)}
                  />
                </div>
              </li>
            ))
          }
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ApplicantDashboard/f_Application/r_ApplicationForm/Skills/c_Skills/index.js